module.exports = __webpack_public_path__ + "static/img/4.7f32813.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/4/zh/4.png
// module id = Yt/d
// module chunks = 0